<template>

    <div class="claims" :class="classes">
        <span class="claim"><i class="fas fa-check mr-5"></i><span class="label">Free Trial</span></span>
        <span class="claim"><i class="fas fa-check mr-5"></i><span class="label">Simple Pricing</span></span>
        <span class="claim d-none d-sm-block "><i class="fas fa-check mr-5"></i><span class="label">24/7 Support</span></span>
    </div>

</template>

<style scoped lang="scss">

    .claims {
        @include font-semibold(13px);
        align-items: center;
        display: flex;
        justify-content: center;
        line-height: 1.6em;
        &.dark {
            color: $color-text;
            i {
                color: $color-primary;
            }
        }
        &.light {
            color:#fff;
            i {
                color: #fff;
            }
        }
        .claim {
            margin-left: 15px;
            &:first-child {
                margin: 0;
            }
            .label {
                opacity: 0.7;
            }
        }
    }

</style>

<script>

export default {

    props: {
        theme: {
            type: String,
            default: 'dark',
        },
    },

    computed: {

        classes() {
            return {
                dark: this.theme === 'dark',
                light: this.theme === 'light',
            };
        },

    },

}

</script>
